var render = function () {
  var _vm$element$attribute

  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.showItem
    ? _c(
        "li",
        {
          attrs: {
            draggable: _vm.editMode ? true : null,
            "aria-selected": _vm.editMode ? _vm.keyboardSelected : null,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-tree-item-wrapper",
            },
            [
              _vm.editMode && _vm.depth > 0 && _vm.canEdit
                ? _c("span", {
                    ref: "sortableHandle",
                    staticClass: "cw-sortable-handle",
                    attrs: {
                      tabindex: 0,
                      "aria-describedby": "operation",
                    },
                    on: {
                      keydown: _vm.handleKeyEvent,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "cw-tree-item-link",
                  class: {
                    "cw-tree-item-link-current": _vm.isCurrent,
                    "cw-tree-item-link-edit": _vm.editMode,
                    "cw-tree-item-link-selected": _vm.keyboardSelected,
                  },
                  attrs: {
                    to: "/structural_element/" + _vm.element.id,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        ((_vm$element$attribute = _vm.element.attributes) ===
                          null || _vm$element$attribute === void 0
                          ? void 0
                          : _vm$element$attribute.title) || "–"
                      ) +
                      "\n            "
                  ),
                  _vm.task
                    ? _c("span", [_vm._v("| " + _vm._s(_vm.solverName))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasReleaseOrWithdrawDate
                    ? _c("span", {
                        staticClass: "cw-tree-item-flag-date",
                        attrs: {
                          title: _vm.$gettext(
                            "Diese Seite hat eine zeitlich beschränkte Sichtbarkeit"
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasWriteApproval
                    ? _c("span", {
                        staticClass: "cw-tree-item-flag-write",
                        attrs: {
                          title: _vm.$gettext(
                            "Diese Seite kann von Teilnehmenden bearbeitet werden"
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasNoReadApproval
                    ? _c("span", {
                        staticClass: "cw-tree-item-flag-cant-read",
                        attrs: {
                          title: _vm.$gettext(
                            "Diese Seite kann von Teilnehmenden nicht gesehen werden"
                          ),
                        },
                      })
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasChildren && !_vm.editMode
            ? _c(
                "ol",
                {
                  class: {
                    "cw-tree-chapter-list": _vm.isRoot,
                    "cw-tree-subchapter-list": _vm.isFirstLevel,
                  },
                },
                _vm._l(_vm.children, function (child) {
                  return _c("courseware-tree-item", {
                    key: child.id,
                    staticClass: "cw-tree-item",
                    attrs: {
                      element: child,
                      currentElement: _vm.currentElement,
                      depth: _vm.depth + 1,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode
            ? _c(
                "draggable",
                _vm._b(
                  {
                    staticClass: "cw-tree-draggable-list",
                    class: {
                      "cw-tree-chapter-list-empty":
                        _vm.nestedChildren.length === 0,
                    },
                    attrs: {
                      tag: "ol",
                      "component-data": _vm.draggableData,
                      handle: ".cw-sortable-handle",
                      elementId: _vm.element.id,
                      list: _vm.nestedChildren,
                      group: {
                        name: "g1",
                      },
                    },
                    on: {
                      end: _vm.endDrag,
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                _vm._l(_vm.nestedChildren, function (el) {
                  return _c("courseware-tree-item", {
                    key: el.id,
                    staticClass: "cw-tree-item",
                    attrs: {
                      element: el,
                      currentElement: _vm.currentElement,
                      depth: _vm.depth + 1,
                      newPos: el.newPos,
                      newParentId: el.newParentId,
                      siblingCount: _vm.nestedChildren.length,
                      elementid: el.id,
                    },
                    on: {
                      sort: _vm.sort,
                      moveItemUp: _vm.moveItemUp,
                      moveItemDown: _vm.moveItemDown,
                      moveItemPrevLevel: _vm.moveItemPrevLevel,
                      moveItemNextLevel: _vm.moveItemNextLevel,
                      childrenUpdated: function childrenUpdated($event) {
                        return _vm.$emit("childrenUpdated")
                      },
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }